export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_INTERNAL_STAFF_FIELD_NAME =
  "staffId";
export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_INTERNAL_STAFF_RESPONSIBILITY_FIELD_NAME =
  "responsibility";
export const MAINTENANCE_TASK_PERSONNEL_ASSIGNMENT_INTERNAL_STAFF_POSITION_FIELD_NAME =
  "position";
